import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import "./styles.scss";

const HelperTextLabel = ({
  helperText,
  meta,
  readonly,
  classes,
  enableHelperTextTooltip,
}) => {
  const target = useRef(null);
  const [shouldShowOverlay, setShouldShowOverlay] = useState(false);

  const shouldShowError = !!(
    !readonly &&
    (meta.touched || meta.submitting) &&
    meta.error
  );

  useEffect(() => {
    setShouldShowOverlay(
      enableHelperTextTooltip &&
        target?.current?.scrollWidth > target?.current?.clientWidth
    );
  }, [enableHelperTextTooltip, target?.current?.scrollWidth, meta.error]);

  return (
    <>
      {(shouldShowError || helperText) &&
        (shouldShowOverlay ? (
          <OverlayTrigger
            target={target.current}
            placement="bottom-start"
            overlay={
              <Tooltip id="helperTextTolltip">
                {meta.error || helperText}
              </Tooltip>
            }
            popperConfig={{
              modifiers: [
                {
                  name: "flip",
                  options: {
                    padding: {
                      bottom: 52,
                    },
                    fallbackPlacements: ["bottom", "top-start"],
                  },
                },
              ],
            }}
            flip
          >
            <Form.Text ref={target} className={classNames(classes?.text)}>
              {shouldShowError ? meta.error : helperText}
            </Form.Text>
          </OverlayTrigger>
        ) : (
          <Form.Text ref={target} className={classNames(classes?.text)}>
            {shouldShowError ? meta.error : helperText}
          </Form.Text>
        ))}
    </>
  );
};

HelperTextLabel.defaultProps = {
  required: false,
  borderless: false,
  meta: {},
  classes: {},
};

HelperTextLabel.propTypes = {
  meta: PropTypes.object,
  readonly: PropTypes.bool,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  classes: PropTypes.shape({
    text: PropTypes.string,
  }),
  enableHelperTextTooltip: PropTypes.bool,
};

export default HelperTextLabel;
